import { create } from 'zustand'

export interface InboxSelectionState {
  selectedThreadId: number | null
  lastSelectedThreadId: number | null
  setSelectedThread: (id: number | null) => void
  rememberSelectedThread: (id: number | null) => void
  clearSelectedThread: () => void
  clearRememberedThread: () => void
}

const useInboxStore = create<InboxSelectionState>((set) => ({
  selectedThreadId: null,
  lastSelectedThreadId: null,
  setSelectedThread: (id) => {
    set({ selectedThreadId: id, lastSelectedThreadId: id })
  },
  rememberSelectedThread: (id) => {
    set({ lastSelectedThreadId: id })
  },
  clearSelectedThread: () => {
    set({ selectedThreadId: null })
  },
  clearRememberedThread: () => {
    set({ lastSelectedThreadId: null })
  },
}))

export default useInboxStore
